import React from 'react';
import Link from 'next/link';
import { Card, Input, Select } from '@avila-tek/ui/src';
import { Address } from '../../../../models';
import { ACTIONS, ACTIONS_TYPE } from './reducer';
import { countries, venezuela } from '../../../../static';
import FormHeader, { FormHeaderProps } from '../FormHeader';

interface AddressFormProps {
  dispatch: React.Dispatch<ACTIONS_TYPE>;
  state: Partial<Address>;
  header: FormHeaderProps;
  readOnly?: boolean;
}

function AddressForm({
  dispatch,
  state,
  header,
  readOnly = false,
}: AddressFormProps) {
  const [municipalities, setMunicipalities] = React.useState([]);
  // const [cities, setCities] = React.useState([]); // Deprecated field Debido a que no se puede filtrar correctamente los municipios por ciudad

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  // get municipalities by state
  React.useEffect(() => {
    if (state.country === 'Venezuela' && state.state) {
      const stateObj = venezuela.filter(
        (object) => object.estado === state.state
      )[0]?.municipios;
      setMunicipalities(stateObj);
    }
  }, [state.country, state.state]);

  // check if fields are filled, to enable the next field
  const isCountryFilled = !!state?.country;
  const isStateFilled = !!state?.state;
  const isMunicipalityFilled = !!state?.municipality;
  const isAddress1Filled = !!state?.address1;
  const isAddress2Filled = !!state?.address2;

  /**
   * @Deprecated
   */
  // get cities by state
  // React.useEffect(() => {
  //   if (state.country === 'Venezuela' && state.state) {
  //     const stateObj = venezuela.filter(
  //       (object) => object.estado === state.state
  //     )[0]?.ciudades;
  //     setCities(stateObj);
  //   }
  // }, [state.country, state.state]);

  return (
    <Card>
      <FormHeader
        href={header.href}
        backBtnText={header?.backBtnText}
        title={header?.title ?? ''}
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Select
              name={ACTIONS.COUNTRY}
              value={state?.country ?? ''}
              label="País"
              onChange={handleChangeSelect}
              required
              disabled={readOnly}
            >
              <option value="" disabled>
                País
              </option>
              {countries.map((c) => (
                <option key={c?.code} value={c?.name}>
                  {c?.name}
                </option>
              ))}
            </Select>
          </div>
          <div className="w-full">
            {state.country === 'Venezuela' ? (
              <Select
                name={ACTIONS.STATE}
                value={state?.state ?? ''}
                label="Estado"
                onChange={handleChangeSelect}
                required
                disabled={!isCountryFilled || readOnly}
              >
                <option disabled value="">
                  Seleccione un estado
                </option>
                {venezuela.map(({ id_estado: idEstado, estado }) => (
                  <option
                    key={String(idEstado)}
                    id={String(idEstado)}
                    value={estado}
                  >
                    {estado}
                  </option>
                ))}
              </Select>
            ) : (
              <Input
                name={ACTIONS.STATE}
                value={state?.state ?? ''}
                label="Estado"
                type="text"
                placeholder="Ingrese un estado"
                onChange={handleChange}
                required
                disabled={!isCountryFilled || readOnly}
              />
            )}
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-5">
          {/**
           * @deprecated address?.city is deprecated, use address?.municipality instead
           */}
          {/* <div className="w-full">
            {state.country === 'Venezuela' ? (
              <Select
                name={ACTIONS.CITY}
                value={state?.city ?? ''}
                label="Ciudad"
                placeholder="Ingrese una ciudad"
                onChange={handleChangeSelect}
                disabled={readOnly}
                required
              >
                <option disabled value="">
                  Seleccione una ciudad
                </option>
                {cities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </Select>
            ) : (
              <Input
                name={ACTIONS.CITY}
                value={state?.city ?? ''}
                label="Ciudad"
                type="text"
                placeholder="Ingrese una ciudad"
                onChange={handleChange}
                disabled={readOnly}
                required
              />
            )}
          </div> */}
          <div className="w-full">
            {state.country === 'Venezuela' ? (
              <Select
                name={ACTIONS.MUNICIPALITY}
                value={state?.municipality ?? ''}
                label="Municipio"
                placeholder="Ingrese un municipio"
                onChange={handleChangeSelect}
                disabled={!isStateFilled || readOnly}
                required
              >
                <option disabled value="">
                  Seleccione un municipio
                </option>
                {municipalities.map((mun) => (
                  <option key={mun.municipio} value={mun.municipio}>
                    {mun.municipio}
                  </option>
                ))}
              </Select>
            ) : (
              <Input
                name={ACTIONS.MUNICIPALITY}
                value={state?.municipality ?? ''}
                label="Municipio"
                type="text"
                placeholder="Ingrese un municipio"
                onChange={handleChange}
                disabled={!isStateFilled || readOnly}
                required
              />
            )}
          </div>
          <div className="w-full">
            <Input
              name={ACTIONS.ADDRESS1}
              value={state?.address1 ?? ''}
              label="Calle/Avenida/Esquina"
              type="text"
              placeholder="Ingrese su dirección"
              onChange={handleChange}
              disabled={!isMunicipalityFilled || readOnly}
              required
            />
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Input
              name={ACTIONS.ADDRESS2}
              value={state?.address2 ?? ''}
              label="Edif/Apto/Piso/Casa"
              type="text"
              placeholder="Ingrese su dirección"
              onChange={handleChange}
              disabled={!isAddress1Filled || readOnly}
              required
            />
          </div>
          <div className="w-full">
            <Input
              name={ACTIONS.ZIP}
              value={state?.zip ?? ''}
              label="Código postal"
              type="number"
              placeholder="Ingrese su código postal"
              onChange={handleChange}
              disabled={!isAddress2Filled || readOnly}
              required
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default AddressForm;
